export const RULE_ASSIGNMENT_TYPE = {
    JOURNEY_TRACKER: 'journeyTracker',
    CONTEXT_HELP: 'contextHelp',
} as const;

export const RULE_ASSIGNMENT_FORM = {
    INVISIBLE: 'invisible',
    DISABLED: 'disabled',
} as const;

export const RULE_GROUP = {
    IDENTITY: 'identity',
    VISITOR: 'visitor',
} as const;

export const RULE_TIME_MODULO_VALUES = {
    A: 'A',
    B: 'B',
} as const;

export const RULE_ARITHMETIC_FUNCTION_TYPES = {
    IS: 'is',
    NOT: 'not',
    GT: 'gt',
    LT: 'lt',
    GE: 'ge',
    LE: 'le',
    EQ: 'eq',
    CONTAINS: 'contains',
    ONE_OF: 'one_of',
} as const;

export const RULE_DATE_KEY_TYPES = {
    MONTH: 'month',
    WEEK: 'week',
    TODAY: 'today',
    YESTERDAY: 'yesterday',
    CUSTOM_ABSOLUTE: 'customAbsolute',
    CUSTOM_RELATIVE: 'customRelative',
} as const;

export const RULE_RELATIVE_DATE_TYPES = {
    LAST_DAY: '1 day',
    LAST_WEEK: '7 days',
    LAST_MONTH: '30 days',
    LAST_TWO_MONTHS: '60 days',
    LAST_THREE_MONTHS: '90 days',
} as const;

export const RULE_LEVEL_TYPE = {
    OPTION: 'option',
    NUMBER: 'number',
    TEXT: 'text',
    PATTERN: 'pattern',
    DATE: 'date',
} as const;

export const RULE_STRING_FUNCTION_TYPES = {
    MATCH_PATTERN: 'mp',
} as const;

export const RULE_SEGMENTATION_VALUE_TYPES = {
    NUMBER: 'number',
    TEXT: 'text',
    DATE: 'date',
    LIST: 'list',
} as const;

export const RULE_TYPE = {
    ADOPT_ROLES: 'adoptRoles',
    ADOPT_LANGUAGES: 'adoptLanguages',
    ADOPT_LOCATIONS: 'adoptLocations',
    SIGNED_IN: 'signedIn',
    ROLES: 'roles',
    HAS_NOT_SEEN: 'hasNotSeen',
    HAS_NOT_COMPLETED: 'hasNotCompleted',
    HAS_NOT_FINISHED: 'hasNotFinished',
    SEEN_COUNT: 'seenCount',
    COMPLETED_COUNT: 'completedCount',
    FINISHED_COUNT: 'finishedCount',
    VISITED_COUNT: 'visitedCount',
    SHOULD_SEE_GUIDE: 'shouldSeeGuide',
    LAST_SEEN_GUIDE: 'lastSeenGuide',
    FACES_GUIDE: 'facesGuide',
    SEEN_RELATED_GUIDE: 'seenRelatedGuide',
    HAS_NOT_SEEN_RELATED_GUIDE: 'hasNotSeenRelatedGuide',
    COMPLETED_RELATED_GUIDE: 'completedRelatedGuide',
    FINISHED_RELATED_GUIDE: 'finishedRelatedGuide',
    TIME_MODULO: 'timeModulo',
    INTERACTED_WITH: 'interactedWith',
    USER_IDS: 'userIds',
    SEGMENTATION_VALUE: 'segmentationValue',
    USER_ATTRIBUTE_VALUE: 'userAttributeValue',
    DO_NOT_START_AUTOMATICALLY: 'doNotStartAutomatically',
} as const;
